const ITEMS = [
  "Hospital Consultancy",
  "Insurance & TPA Support",
  "Cashless Process Support",
  "Hospital Empanelment",
  "Healthcare Training",
  "Healthcare Networking",
  "Certification & Accreditation",
  "Claim Rejection Support",
  "Grievance Handling",
  "Balaghat",
  "Jabalpur",
  "Bhopal",
  "Indore",
  "Raipur",
  "Bhilai",
  "Durg",
  "Bilaspur",
  "Nagpur",
  "Amravati",
  "Akola",
  "Pune",
  "Mumbai",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-[#0B3C5C]/10 bg-[#EFF7F1] py-5"
  >
    <div className="animate-marquee flex w-max items-center gap-10">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center gap-10">
          <span className="font-mono-x whitespace-nowrap text-xs uppercase tracking-[0.3em] text-[#6B8AA0]">
            {item}
          </span>
          <span className="h-1.5 w-1.5 rotate-45 bg-[#5FA832]/50" />
        </span>
      ))}
    </div>
  </div>
);
